import { cn } from '@/lib/utils';

const statusConfig = {
  pending: {
    label: 'In Attesa',
    className: 'status-pending'
  },
  approved: {
    label: 'Approvato',
    className: 'status-approved'
  },
  rejected: {
    label: 'Rifiutato',
    className: 'status-rejected'
  },
  completed: {
    label: 'Completato',
    className: 'status-completed'
  },
  shipped: {
    label: 'Spedito',
    className: 'bg-blue-50 text-blue-800 border-blue-200'
  }
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.pending;
  
  return (
    <span 
      className={cn("status-badge border", config.className)}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
